import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { FC, useCallback, useState } from 'react';
import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';

interface MissingDevicesReasonModalProps {
  open: boolean;
  close: VoidFunction;
  handleConfirmMissingPartsReason: (reason: string) => void;
  handleCancelMissingPartsReason: VoidFunction;
}

const MissingDevicesReasonModal: FC<MissingDevicesReasonModalProps> = ({
  open,
  close,
  handleConfirmMissingPartsReason,
  handleCancelMissingPartsReason,
}) => {
  const lang = useLanguage()[0].CheckInTrayPage;
  const [reason, setReason] = useState<string>('notRequired');

  const handleChangeReason = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReason((event.target as HTMLInputElement).value);
  };

  const handleClose = () => {
    handleCancelMissingPartsReason();
    close();
  };

  // Callback function to receive the result from the child component
  const handleConfirm = useCallback(async () => {
    handleConfirmMissingPartsReason(reason);
    close();
  }, [close, handleConfirmMissingPartsReason, reason]);

  return (
    <Dialog
      open={open}
      title={'Missing Devices'}
      onEnterKey="confirm"
      cancelLabel={lang.cancel}
      confirmLabel={lang.addMissingDevice}
      onConfirm={handleConfirm}
      onCancel={handleClose}
      confirmDisabled={!!(reason == 'notRequired')}
    >
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label" style={{ paddingBottom: '20px' }}>
          Select your comment for missing device/s:
        </FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="notRequired"
          name="radio-buttons-group"
          value={reason}
          onChange={handleChangeReason}
        >
          <FormControlLabel
            value="Missing device is not required for the surgery"
            control={<Radio />}
            label="Missing device is not required for the surgery"
          />
          <FormControlLabel
            value="Missing device to be supplied by Supplier Representative prior to surgery"
            control={<Radio />}
            label="Missing device to be supplied by Supplier Representative prior to surgery"
          />
        </RadioGroup>
      </FormControl>
    </Dialog>
  );
};

export default MissingDevicesReasonModal;
